import React from 'react';
import BoArt from './BoArt';
import { APP_STORE_URL } from '../config/site';

/**
 * Where the page ends up: the App Store. It replaced the pre-launch
 * waitlist at 1.0.0, and keeps its place - and its old anchor, so a
 * /#waitlist link from before launch still lands here. A button in the
 * site's style, not Apple's badge: the hero has the page's one badge.
 */
const Download = () => (
  <section id="download" className="section section-download" aria-labelledby="download-headline">
    <span id="waitlist" className="anchor-alias" aria-hidden="true" />
    <div className="section-inner">
      <div className="download">
        <BoArt pose="record" width={260} className="download-bo" />
        <div className="download-copy">
          <p className="eyebrow">On the App Store</p>
          <h2 id="download-headline" className="h2">
            Find your bell.
          </h2>
          <p className="lead-sm">
            Get stronger with one kettlebell, a simple plan, and people who show up with you.
          </p>
          <p className="small">
            Free to start. Pro when you want more. For iPhone and Apple Watch, on iOS 27.
          </p>
          <div className="download-action">
            <a href={APP_STORE_URL} rel="noopener" className="btn btn-primary btn-large">
              Download on the App Store
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Download;
